import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import App from './App';
import * as serviceWorker from './serviceWorker';
import "bootstrap/dist/css/bootstrap.min.css";
import WebSocket from './hooks/useWebSocket';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AppProvider from './context';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID, // Replace with your Azure AD Client ID
    authority: "https://login.microsoftonline.com/common", // Your tenant ID or 'common'
    redirectUri: `${window?.location?.origin}`, // Your redirect URI
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <WebSocket>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <MsalProvider instance={msalInstance}>
            <AppProvider>
              <App />
            </AppProvider>
          </MsalProvider>
        </GoogleOAuthProvider>
      </WebSocket>
    </PersistGate>
  </Provider>,

  document.getElementById('root')
);

serviceWorker.unregister();
